import StudyingSection from "./StudyingSection";

export default StudyingSection;